module.exports = __webpack_public_path__ + "img/blogpost7.fb8bdb84.jpg";